import { z } from "zod";

export const transferAccountFormSchema = z.object({
  name: z.string(),
  phone: z.string(),
  account: z.string(),
  email: z.string().email("이메일 형식을 확인해 주세요."),
  adConsent: z.boolean(),
  emailConsent: z.boolean(),
  smsConsent: z.boolean(),
});

export type TransferAccountFormType = z.infer<typeof transferAccountFormSchema>;
